import React, { FC, useContext, useEffect, useState } from 'react'
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts'
import Title from '../Title'
import { Paper } from '@mui/material'
import { DataContext } from '../../contexts/DataProvider'
import { getChartDate } from '../../helpers/getChartDate'
import { PRIMARY_COLOR, SECONDARY_COLOR } from '../../utils/colors'
import { getPeriod } from '../../helpers/helpers'
import { Legend } from 'recharts'
import useFetch from '../../hooks/useFetch'
import ChartLoader from '../ChartLoader'
interface ChartData {
  time: string
  planned: number
  completed: number
}
interface UserChartProps {
  selectedUser: string
  apiPath: 'getScheduledExperiments' | 'getScheduledObservations'
  type: 'pro' | 'sdmt' | 'walking'
  label: string
}

const UserChart: FC<UserChartProps> = ({ selectedUser, apiPath, type, label }) => {
  const { activeContract, setError, startDate, endDate, period } = useContext(DataContext)

  const [isLoading, data, error] = useFetch(apiPath, {}, [selectedUser, startDate, endDate, period, activeContract], {
    'studyIds[]': activeContract?.id,
    userId: selectedUser,
    startTime: startDate.format('MM.DD.YYYY'),
    endTime: endDate.format('MM.DD.YYYY'),
    period: getPeriod(period),
    type,
  })
  const [chartData, setChartData] = useState<ChartData[]>([])

  useEffect(() => {
    const results =
      data?.data?.map((contract) => {
        const time = getChartDate(period, contract)
        return {
          time,
          planned: contract?.scheduledTests,
          completed: contract?.completedTests,
        }
      }) || []
    setChartData(results)
  }, [data])

  useEffect(() => {
    if (!error) {
      return
    }
    setError({ isError: true, errorMessage: 'Error during fetching user data' })
  }, [error])

  return (
    <Paper sx={{ p: 2, pb: 4, mb: 3, position: 'relative' }}>
      <Title>{label}</Title>
      {isLoading ? (
        <ChartLoader />
      ) : (
        <ResponsiveContainer width="100%" height={260}>
          <LineChart data={chartData} margin={{ top: 5, right: 30, left: -10, bottom: 5 }}>
            <XAxis dataKey="time" fontSize={12} tickMargin={15} />
            <YAxis fontSize={12} tickMargin={10} />
            <Tooltip />
            <Line type="monotone" dataKey="planned" stroke={PRIMARY_COLOR} />
            <Line type="monotone" dataKey="completed" stroke={SECONDARY_COLOR} />
            <Legend verticalAlign="bottom" height={-20} />
            <CartesianGrid strokeDasharray="3 3" />
          </LineChart>
        </ResponsiveContainer>
      )}
    </Paper>
  )
}
export default UserChart
